
import Repository from '@/app/repositories/repository'
import {RepositoryFactory} from '@/app/repositories/repository-factory.js'

const AccountRepository = RepositoryFactory.get('account');

export default Object.assign(AccountRepository, {
    login: function(data){
        return Repository.post(`/account/login`, data);
    },
    loginOut: function(){
        return Repository.get(`/account/loginOut`);
    },
    register: function(data){
        return Repository.post(`/account/register/`, data)
    },
    preResetPassword: function(data){
        return Repository.get(`/account/preResetPassword?email=`+ data)
    },
    resetPassword: function(data){
        return Repository.post(`/account/resetPassword`, data)
    },
    // registerValidate(uid, code){
    //     return Repository.get(`/account/register?area=Identity&userId=${uid}&code=${code}`);
    // }
});
